<template>
    <vs-popup class="gopos-ordr-detail update-order-staff-popup" title="" :class="{'is-combo': current_type == 'combo'}" :active.sync="editOrderStaffPopup.isOpen" fullscreen>
        <div class="flex align-center mb-4 header">
            <p class="text-xl text-black font-extrabold mr-4" style="white-space: nowrap">Choose staff for: </p>
            <div class="flex align-center" v-if="category && category.type != 'combo'">
                <div class="text-lg flex-center category-item mr-4" :style="`background: ${category.color_code || '#9e9e9e'}`">
                    <p>{{ category.name }}</p>
                </div>
                <div class="service-item" v-if="service"><span class="mr-4">{{ service.name }}</span> ${{ service.price || 0 }}</div>
            </div>
            <div class="flex align-center" v-else-if="service">
                <div class="text-lg flex-center category-item mr-4" :style="`background: ${category.color_code}`">
                    <p>{{ service.name }}</p>
                </div>
                <div class="flex align-center combo-list" id="combo-list" style="scroll-behavior: smooth;">
                    <div class="flex-col justify-between combo-item mr-4" v-for="(combo, index) in combo_list" :key="index" :class="{'active': index == active_index}" @click.stop="setActiveCombo(index)">
                        <div class="text-lg font-bold flex align-center justify-between">
                            <p class="mr-4 combo-name" v-if="combo.item.item_detail">{{ combo.item.item_detail.name }}</p>
                            <span>${{ combo.item.price || 0 }}</span>
                        </div>
                        <div class="text-sm staff-name" v-if="combo.staff">{{ combo.staff.name }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="con-input-search vs-table--search m-0 w-full mb-4" style="max-width: unset">
            <input type="text" class="input-search vs-table--search-input rounded-item border-custom border-color-custom py-3 text-sm w-full" @input="searchStaff" placeholder="Search staff...">
            <i class="vs-icon notranslate icon-scale material-icons null">search</i>
        </div>
        <div class="staff-list pl-4 pt-4">
            <vs-row vs-w="12" v-if="staffList && staffList.length > 0">
                <vs-col class="w-full sm:w-1/2 md:w-1/3" v-for="(staff, index) in staffList" :key="index" @click.native="selectStaff(staff)">
                    <my-staff-item type="grid" class="mr-4 mb-4" :staffData="staff" dense></my-staff-item>
                </vs-col>
            </vs-row>
            <div class="p-base flex-center" v-else>No data available</div>
        </div>
        <div class="flex-center mt-5" v-if="current_type == 'combo'">
            <vs-button type="border" color="danger" class="mr-4" @click="editOrderStaffPopup.isOpen = false">Cancel</vs-button>
            <vs-button :disabled="!completed_selection" @click="confirmItem">Confirm</vs-button>
        </div>
    </vs-popup>
</template>

<script>
export default {
    name: "update-order-staff-popup",
    props: {
        editOrderStaffPopup: {
            type: Object,
            required: true
        },
        active_data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            search: "",
            combo_list: [],
            active_index: 0,
            selected_staff: null,
            completed_selection: false
        }
    },
    watch: {
        service: {
            immediate: true,
            deep: true,
            handler() {
                this.initData();
            }
        }
    },
    methods: {
        initData() {
            this.search = "";
            this.combo_list = [];
            this.active_index = 0;
            this.selected_staff = null;
            this.completed_selection = false;
            
            if(this.service && this.service.combo_item != undefined && this.service.combo_item.length > 0) {
                let combo_list = [];
                for(let i = 0; i < this.service.combo_item.length; i++) {
                    combo_list.push({
                        // ...this.service.combo_item[i],
                        item: this.service.combo_item[i],
                        staff: null
                    })
                }
                this.combo_list = combo_list;
            }
        },
        setActiveCombo(index) {
            this.active_index = index;
        },
        searchStaff({target}) {
            this.search = target.value;
        },
        selectStaff(staff) {
            if(this.current_type == 'combo') {
                if(this.combo_list && this.combo_list[this.active_index]) {
                    this.combo_list[this.active_index].staff = staff;
                    let i = 0;
                    for(; i < this.combo_list.length; i++) {
                        if(!this.combo_list[i].staff) {
                            this.active_index = i;
                            break;
                        }
                    }
                    if(i == this.combo_list.length) {
                        this.completed_selection = true;
                    } else {
                        let elem = document.getElementById("combo-list");
                        if(elem) {
                            elem.scrollLeft = i*170;
                        }
                    }
                }
            } else {
                this.selected_staff = staff;
                this.confirmItem();
            }
        },
        confirmItem() {
            let arr = [];
            if(this.current_type == "combo") {
                arr = this.combo_list.map((item) => { 
                    return {
                        combo_name: this.service.name,
                        item_id: item.item.item_id,
                        item_name: item.item.item_detail ? item.item.item_detail.name: null,
                        item_type: this.current_type_number,
                        price: item.item.price,
                        quantity: 1,
                        staff_id: item.staff.user_id,
                        staff_name: item.staff.name,
                        amount: item.amount,
                        giftcard_value: item.giftcard_value,
                        combo_id: item.item.item_combo_id
                    };
                });
            } else {
                arr = [{
                    combo_name: null,
                    item_id: this.service.id,
                    item_name: this.service.name,
                    item_type: this.current_type_number,
                    price: this.service.price,
                    quantity: 1,
                    staff_id: this.selected_staff.user_id,
                    staff_name: this.selected_staff.name,
                    amount: this.service.amount,
                    giftcard_value: this.service.giftcard_value,
                    combo_id: null
                }];
            }
            this.$emit("completeSelect", arr);
            this.editOrderStaffPopup.isOpen = false;
        }
    },
    computed: {
        staffList() {
            return this.$store.getters["staffList/staffListWithSearch"](this.search);
        },
        service() {
            let service = null;
            if(this.active_data && this.active_data.service && this.category) {
                service = this.active_data.service;
                if(this.category.type == "combo") {
                    let data = this.$store.getters["serviceList/comboListActive"].items;
                    for(let i = 0; i < data.length; i++) {
                        if(data[i].id == service.id) {
                            service = data[i];
                            break;
                        }
                    }
                }
            }
            return service;
        },
        category() {
            if(this.active_data && this.active_data.category) {
                return this.active_data.category;
            }
            return null;
        },
        current_type() {
            if(this.category && this.category.type) {
                return this.category.type;
            }
            return null;
        },
        current_type_number() {
            switch(this.current_type) {
                case "service": return 1;
                case "product": return 2;
                case "combo": return 3;
                case "gift_card": return 4;
                default: return 0;
            }
        }
    },
    created() {
        this.$store.dispatch("staffList/GET_STAFF_LIST", { page: 1, "per-page": 100 });
    }
}
</script>

<style lang="scss">
.update-order-staff-popup {
    &.con-vs-popup {
        z-index: 53001;
        .vs-popup--header {
            background: transparent;
        }
        .vs-popup--content {
            margin: 0;
            padding: 0 1rem;
            width: 100%;
            .category-item, .combo-item {
                display: flex;
                padding: 0.2rem 0.7rem;
                border-radius: 8px;
                height: 53px;
            }
            .category-item {
                color: #fff;
                p {
                    width: 120px;
                    text-align: center;
                }
            }
            .service-item {
                white-space: nowrap;
            }
            .category-item p, .combo-item .combo-name, .combo-item .staff-name {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
            }
            .combo-item {
                cursor: pointer;
                border: 1px solid #aaa;
                transition: 0.2s ease;
                &.active {
                    border-color: #2979FF;
                    background: #2979FF;
                    color: #fff;
                }
                .combo-name {
                    width: 100px;
                }
                .staff-name {
                    width: 143px;
                }
            }
            .combo-list {
                width: calc(100vw - 372px);
                overflow: auto;
            }
            @media (max-width: 500px) {
                .header {
                    width: 100%;
                    overflow: auto;
                }
                .combo-list {
                    width: 100%;
                }
            }
            .staff-list {
                height: calc(100vh - 210px);
                overflow: auto;
                margin: 0 -14px;
                @media (max-width: 995px) {
                    height: calc(100vh - 235px);
                }
            }
        }
        &.is-combo {
            .vs-popup--content {
                .staff-list {
                    height: calc(100vh - 260px);
                    @media (max-width: 995px) {
                        height: calc(100vh - 285px);
                    }
                }
            }
            .vs-popup--close {
                display: none;
            }
        }
        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
        .vs-popup--background {
            pointer-events: none;
        }
    }
}
</style>